export const SELECTION_COLUMN_ID = 'selection_column';
export const ACTIONS_COLUMN_ID = 'actions';

export * from './test-ids';
